import { executeRequest, Request } from '@jfs/network'
import { getSignUpOtpRequestBody } from './../data/request/requestbody'
import { OtpParser } from './../network/parsers/GetOtpParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = OtpParser(data)
  return respData
}

const generateOtpOnSignUp = (mobileNumber: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.generateOtpOnSignUp,
    method: 'POST',
    config: sitConfig(tokens), //FIXME: change to generic config once api's are deployed on sit via api gateway
    body: getSignUpOtpRequestBody(mobileNumber),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { generateOtpOnSignUp }
